import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ReferenceNavigasi } from '../../../models/master-user/reference-navigasi.model';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { ReferenceNavigasiAdapter } from '../../adapter/master-user/reference-navigasi.adapter.service';
import { environment } from 'src/environments/environment';
import { ClinicEnvironmentService } from '../../clinic-environment.service';

@Injectable({
  providedIn: 'root',
})
export class ReferenceNavigasiApiService implements ApiService<ReferenceNavigasi> {
  constructor(
    private adapter: ReferenceNavigasiAdapter,
    private httpClient: HttpClient,
    private clinicEnv: ClinicEnvironmentService
  ) {}

  public getAll(): Observable<ReferenceNavigasi[]> {
    return this.httpClient
      .get(
        `${environment.urlV2}/data-klinik/${this.clinicEnv.clinicId}/clinic-type/${this.clinicEnv.clinicType}/reference-navigasi`
      )
      .pipe(
        map((data: any) => {
          if (!data) return [];
          return data.responses.referenceNavigasi.map((val: ReferenceNavigasi) =>
            this.adapter.adapt(val)
          );
        }),
        catchError((err) => throwError(err))
      );
  }
  public getNavigasi(params?: any): Observable<ReferenceNavigasi[]> {
    const query = params ? `?nama=${params}` : '';

    return this.httpClient
      .get(
        `${environment.urlV2}/clinic-type/${this.clinicEnv.clinicType}/reference-navigasi${query}`
      )
      .pipe(
        map((data: any) => {
          if (!data) return [];
          return data.responses.referenceNavigasi.map((val: ReferenceNavigasi) =>
            this.adapter.adapt(val)
          );
        }),
        catchError((err) => throwError(err))
      );
  }

  public getReferenceNavigasiAll(): Observable<ReferenceNavigasi[]> {
    return this.httpClient.get(`${environment.urlV2}/reference-navigasi/all`).pipe(
      map((data: any) => {
        if (!data) return [];
        return data.responses.referenceNavigasi.map((val: ReferenceNavigasi) =>
          this.adapter.adapt(val)
        );
      }),
      catchError((err) => throwError(err))
    );
  }
}
